"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ErrorModal = exports.WarningModal = exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Button = _interopRequireDefault(require("../Button"));

var _icons = require("@ant-design/icons");

var _Modal = require("./Modal.style");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * 彈窗組件
 */
var Modal = function Modal(_ref) {
  var _ref$closable = _ref.closable,
      closable = _ref$closable === void 0 ? true : _ref$closable,
      _ref$title = _ref.title,
      title = _ref$title === void 0 ? "" : _ref$title,
      visible = _ref.visible,
      confirmLoading = _ref.confirmLoading,
      _ref$okText = _ref.okText,
      okText = _ref$okText === void 0 ? "確定" : _ref$okText,
      _ref$cancelText = _ref.cancelText,
      cancelText = _ref$cancelText === void 0 ? "取消" : _ref$cancelText,
      okButtonProps = _ref.okButtonProps,
      onOk = _ref.onOk,
      onCancel = _ref.onCancel,
      footer = _ref.footer,
      _ref$getContainer = _ref.getContainer,
      getContainer = _ref$getContainer === void 0 ? false : _ref$getContainer,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? "520px" : _ref$width,
      children = _ref.children;
  return /*#__PURE__*/_react.default.createElement(_Modal.UiModal, {
    closable: closable,
    width: width,
    title: title,
    visible: visible,
    confirmLoading: confirmLoading,
    okText: okText,
    cancelText: cancelText,
    okButtonProps: okButtonProps,
    onOk: onOk,
    onCancel: onCancel,
    getContainer: getContainer,
    footer: footer
  }, children);
};

var _default = Modal;
exports.default = _default;
Modal.propTypes = {
  closable: _propTypes.default.bool,
  title: _propTypes.default.node,
  visible: _propTypes.default.bool,
  confirmLoading: _propTypes.default.bool,
  okText: _propTypes.default.string,
  cancelText: _propTypes.default.string,
  okButtonProps: _propTypes.default.object,
  onOk: _propTypes.default.func,
  onCancel: _propTypes.default.func,
  footer: _propTypes.default.node,
  getContainer: _propTypes.default.any,
  width: _propTypes.default.string,
  children: _propTypes.default.node
};

var WarningModal = function WarningModal(_ref2) {
  var visible = _ref2.visible,
      onOk = _ref2.onOk,
      onCancel = _ref2.onCancel,
      _ref2$message = _ref2.message,
      message = _ref2$message === void 0 ? "該名稱已被其他資料使用，確定要儲存？" : _ref2$message;
  return /*#__PURE__*/_react.default.createElement(_Modal.UiWaringModal, {
    visible: visible,
    onOk: onOk,
    onCancel: onCancel,
    closable: false,
    footer: [/*#__PURE__*/_react.default.createElement(_Button.default.IconButton, {
      key: "back",
      variant: "white",
      onClick: onCancel,
      icon: /*#__PURE__*/_react.default.createElement("i", {
        className: "material-icons",
        style: {
          fontSize: "20px"
        }
      }, "close"),
      full: false
    }, "\u53D6\u6D88"), /*#__PURE__*/_react.default.createElement(_Button.default.IconButton, {
      key: "submit",
      variant: "blue",
      onClick: onOk,
      icon: /*#__PURE__*/_react.default.createElement("i", {
        className: "material-icons",
        style: {
          fontSize: "20px"
        }
      }, "panorama_fish_eye"),
      full: false
    }, "\u78BA\u5B9A")]
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "content"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "icon"
  }, /*#__PURE__*/_react.default.createElement(_icons.ExclamationOutlined, null)), /*#__PURE__*/_react.default.createElement("div", {
    className: "text"
  }, message)));
};

exports.WarningModal = WarningModal;
WarningModal.propTypes = {
  visible: _propTypes.default.bool,
  onOk: _propTypes.default.func,
  onCancel: _propTypes.default.func,
  message: _propTypes.default.string
};

var ErrorModal = function ErrorModal(_ref3) {
  var visible = _ref3.visible,
      onCancel = _ref3.onCancel,
      _ref3$message = _ref3.message,
      message = _ref3$message === void 0 ? "名稱、作答方式、預設列印方式欄位不得空白" : _ref3$message;
  return /*#__PURE__*/_react.default.createElement(_Modal.UiErrorModal, {
    visible: visible,
    onCancel: onCancel,
    closable: false,
    footer: [/*#__PURE__*/_react.default.createElement(_Button.default.IconButton, {
      key: "back",
      variant: "white",
      onClick: onCancel,
      icon: /*#__PURE__*/_react.default.createElement("i", {
        className: "material-icons",
        style: {
          fontSize: "20px"
        }
      }, "close"),
      full: false
    }, "\u53D6\u6D88")]
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "content"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "icon"
  }, /*#__PURE__*/_react.default.createElement(_icons.CloseOutlined, null)), /*#__PURE__*/_react.default.createElement("div", {
    className: "text"
  }, message)));
};

exports.ErrorModal = ErrorModal;
ErrorModal.propTypes = {
  visible: _propTypes.default.bool,
  onCancel: _propTypes.default.func,
  message: _propTypes.default.string
};